import { render, staticRenderFns } from "./ConvocationRegistrationPrint.vue?vue&type=template&id=16ad234b&scoped=true&"
import script from "./ConvocationRegistrationPrint.vue?vue&type=script&lang=js&"
export * from "./ConvocationRegistrationPrint.vue?vue&type=script&lang=js&"
import style0 from "./ConvocationRegistrationPrint.vue?vue&type=style&index=0&id=16ad234b&lang=scss&scoped=true&"
import style1 from "./ConvocationRegistrationPrint.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ad234b",
  null
  
)

export default component.exports